/**
 * Convex Auth Provider
 * Wraps the app with Convex Auth for authentication and real-time data
 */

import { ConvexAuthProvider } from '@convex-dev/auth/react';
import { ConvexReactClient } from 'convex/react';
import type { ReactNode } from 'react';

// Get Convex URL from environment
const convexUrl = import.meta.env.VITE_CONVEX_URL as string;

// Create client only if URL is available
const convex = convexUrl ? new ConvexReactClient(convexUrl) : null;

interface Props {
    children: ReactNode;
}

export function ConvexProvider({ children }: Props) {
    // If no Convex URL configured, render children without provider
    // This allows the app to run in development before Convex is set up
    if (!convex) {
        console.warn('VITE_CONVEX_URL not set. Convex features disabled.');
        return <>{children}</>;
    }

    return (
        <ConvexAuthProvider client={convex}>
            {children}
        </ConvexAuthProvider>
    );
}

// Export client for use in auth actions
export { convex };
